// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import PropTypes from "prop-types";

export const breadcrumbPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  url: PropTypes.string,
  name: PropTypes.string.isRequired,
});
